import type { WeightUnit } from "@kanpla/api-contract";

import type { UnitSystem, Category } from "~/api/products/types";

/** A scale reading net of tare, in the unit the scale weighed in. */
export type CapturedWeight = {
  weight: number;
  unit: WeightUnit;
  /** Decimals the scale reports at; the display precision. */
  decimals: number;
};

type DiscountBase = {
  id: string;
};

type DiscountHybridBilling = DiscountBase & {
  type: "hybrid-billing";
};

type DiscountStampCard = DiscountBase & {
  type: "stamp-card";
  stampCardRuleId: string;
};

export type BasketDiscount = DiscountStampCard | DiscountHybridBilling;

type BasketItemBase = {
  id: string;
  productId: string;
  quantity: number;
  discounts: BasketDiscount[];
};

type BasketItemRegular = BasketItemBase & {
  type: "regular";
};

export type VariantChoice = {
  id: string;
  variantId: string;
  quantity: number;
};

export type BasketItemVariant = BasketItemBase & {
  type: "variant";
  choices: VariantChoice[];
};

export type BasketItemWeighted = BasketItemBase & {
  type: "weighted";
  weight: number;
  weightUnit: WeightUnit;
  weightDecimals: number;
  unitSystem: Exclude<UnitSystem, "piece">;
};

export type BasketItem =
  | BasketItemRegular
  | BasketItemVariant
  | BasketItemWeighted;

export type DiningOption = {
  inputId: string;
  value: string;
};

export type SessionStatus = "idle" | "active" | "inactive";

export type KioskSession = {
  orderId: string; // locally generated order id
  serviceId: string; // active service id of the transaction

  basket: BasketItem[];

  childId: string | null;

  diningOption: DiningOption | null;

  locale: string;

  postCheckoutTextInputs: Record<string, string> | null;

  shopperName: string | null;

  lastUpdatedAt: number;

  redeemingSessionStatus: SessionStatus;

  activeCategoryId: Category["id"] | null;
};

export type KioskSessionStore = KioskSession | null;

export const REWARDS_CATEGORY_ID = "stamp_card_rewards_category_id";
